<template>
    <div class="ld-select-checkbox con-select w-full">

        <label v-if="label" for="" class="vs-select--label">{{ label }}</label>

        <div class="input-select-con">
            <button
                :ref="name"
                @click="setIsShow(true)"
                class="placeholder input-select vs-select--input"
                :class="{'is-custom-icon': icon && iconPack}">
                    <p>{{placeholder}}</p>
                    <div v-if="icon && iconPack">
                        <i class="vs-icon icon-scale vs-input--icon feather icon-search null icon-after"></i>
                    </div>

                    <div v-else>
                        <button type="button" :class="{'button-clear-show': isShow}" class="icon-select-clear vs-select--icon-clear">
                            <i class="material-icons">close</i>
                        </button>

                        <i v-show="!isShow" class="vs-select--icon material-icons">
                            keyboard_arrow_down
                        </i>
                    </div>
            </button>

            <input autocomplete="off" :id="name" type="hidden" :name="name" v-model="selected">

            <div
                v-show="isShow"
                :class="{'fade-in-top': isShow}"
                class="vs-select--options vs-select-primary mt-2">
                    <input autocomplete="off" type="text" class="searching" @input="searching" v-model="search"/>
                    <select-items
                        v-if="checkbox && list.length"
                        :list.sync="listItems"
                        :select="select"
                        :model.sync="checkbox"
                        :minChecked="minChecked"
                    />

                    <h3 v-if="!list.length">Nenhum item encontrado</h3>

            </div>
        </div>
        <span></span>
    </div>
</template>

<script>
import selectItems from './LdSelectCheckboxItems';

export default {
    name: "LdSelectCheckbox",
    components: {
        selectItems
    },
    props: {
        model: {
            required: true
        },
        minChecked: {
            type: Number,
            default: 3,
        },
        label: String,
        name: String,
        iconPack: String,
        icon: String,
        list: Array,
        blur: {
            type: Function,
            default: () => {}
        },
        select: {
            type: Function,
            default: () => {}
        },
        update: Array
    },
    data() {
        return {
            isShow: false,
            placeholder: null,
            checkbox: null,
            listItems: null,
            search: null,
        };
    },
    computed: {
        selected: {
            get() {
                return this.model;
            },
            set(value) {
                this.$emit("update:model", value);
                this.cleanSpanError();
            }
        },
        selectName() {
            return "select" + this.name + "option";
        }
    },
    methods: {
        setListItems(list) {
            this.listItems = JSON.parse(JSON.stringify(list));
        },
        resetSearch() {
            this.search = null;
            this.setListItems(this.list);
        },
        searching(event) {
            const value = event.target.value;
            let list = JSON.parse(JSON.stringify(this.list));

            if (!value) {
                this.setListItems(this.list);
                return null;
            }

            function filter(_list) {
                const listFilter = [];

                _list.forEach(function(item) {
                    if (Array.isArray(item.value)) {
                        const itemList = filter(item.value);

                        if (itemList.length) {
                            listFilter.push({key: item.key, value: itemList});
                        }

                    } else {
                        if (item.key.toLowerCase().includes(value.toLowerCase())) {
                            listFilter.push(item);
                        }
                    }
                });

                return listFilter;
            }

            this.setListItems(filter(list));

        },
        setPlaceholder() {
            if (this.checkbox) {

                let placeholder = null;
                const quantityItems = this.checkbox.length;
                const items = [];

                const getItems = function(list) {
                    list.forEach(_item => {
                        if (Array.isArray(_item.value)) {
                            getItems(_item.value);
                        } else {
                            items.push(_item.value);
                        }
                    })
                }

                getItems(this.listItems);

                switch (quantityItems) {
                    case 0:
                        placeholder = 'Nenhum item selecionado';
                        break;
                    case 1:
                        placeholder = this.checkbox[0];
                        break;

                    default:
                        if (quantityItems === items.length) {
                            placeholder = `${quantityItems} itens selecionados`;
                        } else {
                            placeholder = `${quantityItems} itens selecionados`;
                        }
                        break;
                }

                this.placeholder = placeholder;
            }
        },
        cleanSpanError() {
            try {
                const input = document.querySelector(`#${this.name}`);

                if (input) {
                    const spanError = input.parentNode.parentNode.parentElement.querySelector('.ld-alert');

                    if (spanError) {
                        spanError.remove();
                    }
                }

            } catch(error) {
                console.error(error);
            }
        },
        setIsShow(value) {
            this.isShow = value;
        },
        hide(event) {
            const $label = this.$el.querySelector(".placeholder");
            const $list = this.$el.querySelector(".vs-select--options");
            const self = this;
            const target = event.target;

            if (target !== $label && !$list.contains(target)) {
                self.setIsShow(false);
            }
        },
        showListInfocus() {
            if (this.$el) {
                const $inputPlaceholder = this.$el.querySelector('.placeholder');

                if ($inputPlaceholder) {
                    $inputPlaceholder.addEventListener('focus', () => {
                        this.setIsShow(true);
                    });
                }

            }
        },
        setCheckboxInitialValue() {
            if (this.model && this.model.length) {
                this.checkbox = [...this.model];
            } else {
                this.checkbox = [];
            }
        }
    },
    watch: {
        checkbox() {
            this.setPlaceholder();
            this.selected = this.checkbox;
        },
        list() {
            if (!this.placeholder) {
                this.setPlaceholder();
            }
        },
        isShow() {
            if (!this.isShow) {
                this.resetSearch();
                this.blur({data: this.model});
            }
        },
        update() {
            if (this.update && Array.isArray(this.update) && this.update.length) {
                this.checkbox = this.update;
            }
        },
        model() {
            if (!this.model) {
                this.checkbox = [];
            }
        }
    },
    mounted() {
        this.setPlaceholder();
        this.setCheckboxInitialValue();
        this.showListInfocus();
        this.setListItems(this.list);

        window.addEventListener("click", this.hide);
    }
};
</script>

<style lang="scss">

.ld-select-checkbox {

    .con-slot-label {
        white-space: nowrap;
        text-align: left;
    }

    .vs-select--label {
        display: block;
        text-align: left;
    }

    & .vs-select--options {
        position: absolute !important;
        min-width: 100%;
        max-height: initial !important;

        span {
            color: #626262;
            font-size: 1rem;
            font-weight: normal;
        }
    }

    .vs-select--options ul:not(.subnivel){
        padding: 15px 5px;
    }

    .is-custom-icon {
        padding: 0.7rem 3rem 0.7rem 1rem !important;
    }

    .searching {
        width: 100%;
        height: 30px;
        margin: 5px 0 10px 0;
        padding: 10px;
        border: 2px solid rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        color: inherit;
        font-size: 1rem;
    }

    .placeholder {
        display: flex;
        width: 100%;
        height: 38px;
        padding-right: 15px;
        cursor: pointer;
        font-weight: 500;
        font-family: 'Montserrat', sans-serif;
        background: #fff;

        & p {
            max-width: 95%;
            pointer-events: none;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .disabled {
        pointer-events: none;
        height: 60px;
    }

    .vs-select--item {
        min-height: 28px;
        font-family: 'Montserrat', sans-serif;
    }

    .button-clear-show {
        opacity: 1 !important;
        visibility: visible;
        transform: translateY(-50%) rotate(0);
        transition: transform 0.2s;
    }
}
</style>
